import React, { Component } from 'react';
import './CustomServices.css';
import classNames from 'classnames';
import { inject } from 'mobx-react';

import CustomService from './CustomService';
import { Tooltip } from 'antd';

@inject('translationsStore', 'step3RegistrationStore', 'registrationStore')
export default class CustomServices extends Component {
  addCustomService = service => {
    this.props.step3RegistrationStore.addCustomService(service);
  };

  draftCustomService = (index, service) => {
    this.props.step3RegistrationStore.draftCustomService(index, service);
  };

  updateCustomService = (index, service) => {
    this.props.step3RegistrationStore.updateCustomService(index, service);
  };

  removeCustomService = index => () => {
    this.props.step3RegistrationStore.removeCustomService(index);
  };

  labelForKm = () => {
    const {
      translationsStore: { current: t },
      registrationStore: { car }
    } = this.props;

    if ((car.registrationOdometer || 0) === 0) {
      return;
    }
    return ` (${t['shared']['lblFrom']} ${car.registrationOdometer})`;
  };

  labelForMonts = () => {
    const {
      translationsStore: { current: t }
    } = this.props;

    return ` (${t['shared']['lblFrom']} ${t['shared']['lblToday']})`;
  };

  render() {
    const {
      disabled,
      step3RegistrationStore,
      translationsStore: { current: t }
    } = this.props;

    const cls = classNames({
      CustomServices: true,
      [this.props.className]: !!this.props.className,
      disabled
    });

    const nextIndex = step3RegistrationStore.customServices.services.filter(service => service._draft === undefined).length;

    return (
      <div className={cls}>
        <div className="header">
          <div>{t['registration_3']['maintenances']['other']['description']}</div>
          <div>
            <span>{t['registration_3']['maintenances']['other']['km']}</span>
          </div>
          <div>
            <Tooltip title="ww">
              <span>{t['registration_3']['maintenances']['other']['months']}</span>
            </Tooltip>
          </div>
          <div />
        </div>
        <div className="body">
          {(step3RegistrationStore.customServices.services || []).map((service, index) => {
            // no drafts wanted here
            if (!!service._draft) return undefined;
            return <CustomService service={service} onDelete={this.removeCustomService(index)} key={`service_${index}`} serviceIndex={index} />;
          })}
          <CustomService
            onAdd={this.addCustomService}
            editable={true}
            disabled={disabled}
            serviceIndex={nextIndex}
            services={step3RegistrationStore.customServices.services}
            servicesToggledChanges={step3RegistrationStore.servicesToggledChanges}
            onDraft={this.draftCustomService}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/CustomServices/CustomServices.js